import { render, staticRenderFns } from "./platformContent.vue?vue&type=template&id=411a9f9a&scoped=true&"
import script from "./platformContent.vue?vue&type=script&lang=js&"
export * from "./platformContent.vue?vue&type=script&lang=js&"
import style0 from "./platformContent.vue?vue&type=style&index=0&id=411a9f9a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411a9f9a",
  null
  
)

export default component.exports